// Collaborative presence scoping.
//
// All collaborators on a LaTeX *project* share one Yjs room (awareness is
// per-room). Each client broadcasts which file it is viewing as
// `currentFile` in its awareness state. Presence shown in the editor must be
// scoped to the *document* (file) the local user is viewing — not every user
// in the project room.
//
// Kept dependency-free (no Yjs/DOM imports) so it is unit-testable in isolation.

export interface PresenceUser {
  clientId: number;
  name: string;
  color: string;
  currentFile?: string;
}

/**
 * Return only the collaborators viewing the same file as the local user.
 * `localFile` is the local client's `currentFile` (undefined before a file is
 * opened — in which case only other not-yet-in-a-file users match).
 */
export function selectPresenceForFile<T extends { currentFile?: string }>(
  users: T[],
  localFile: string | undefined,
): T[] {
  // Only collaborators viewing the same document (file) as the local user.
  return users.filter((u) => u.currentFile === localFile);
}
